import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SportAthletesIndexTable from './SportAthletesIndexTable';

function SportAthletesIndex(props) {
    return (
        <div>
            <div className="row p-2">
                <div className="col">
                    <SportAthletesIndexTable
                        sportAthletesIndexUrl={sportAthletesIndexUrl}
                        sportAthletesStoreUrl={sportAthletesStoreUrl}
                        sportAthletesCreateUrl={sportAthletesCreateUrl}
                        sportAthletesUpdateUrl={sportAthletesUpdateUrl}
                        sportAthletesDeleteUrl={sportAthletesDeleteUrl}
                    />
                </div>
            </div>
        </div>
    );
}

export default SportAthletesIndex;
if (document.getElementById('SportAthletesIndex')) {
    var rootEl = document.getElementById('SportAthletesIndex');
    ReactDOM.render(
        <App>
            <SportAthletesIndex />
        </App>,
        rootEl,
    );
}
